(function () {
  var SKU_SEARCH_FIELDS = 'title,product_type,variants.title,vendor,variants.sku';
  var SEARCH_BUTTON_STYLE_ID = 'metamall-sku-search-button-style';

  function installSearchButtonStyle() {
    if (document.getElementById(SEARCH_BUTTON_STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = SEARCH_BUTTON_STYLE_ID;
    style.textContent = [
      '.search__field input:not(:placeholder-shown){padding-inline-end:10rem;}',
      '.search__field input:not(:placeholder-shown)~.search__reset{inset-inline-end:5.6rem;}',
      '.search__field input:not(:placeholder-shown)~.search__reset span{white-space:nowrap;}',
      '.search__field input:not(:placeholder-shown)~.predictive-search-icon{opacity:1;pointer-events:auto;}',
      '.search__field input:not(:placeholder-shown)~.search__icon-search{z-index:2;}'
    ].join('');
    document.head.appendChild(style);
  }

  function cleanQuery(value) {
    return (value || '').trim().replace(/[\uFF0A*]+$/g, '');
  }

  function isSkuQuery(value) {
    var q = cleanQuery(value);

    if (!q) return false;
    if (/[\u3040-\u30ff\u3400-\u9fff]/.test(q)) return false;

    return /^(?=.*[A-Za-z])(?=.*\d)(?=.*-)[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+$/.test(q);
  }

  function getSearchInput(form) {
    return form && form.querySelector ? form.querySelector('input[name="q"]') : null;
  }

  function isSearchForm(form) {
    var action = form && form.getAttribute ? form.getAttribute('action') || '' : '';

    return (
      form &&
      form.matches &&
      form.matches('form') &&
      getSearchInput(form) &&
      (form.getAttribute('role') === 'search' ||
        action.indexOf('/search') !== -1 ||
        (form.id || '').indexOf('Search') !== -1 ||
        form.classList.contains('yl-search-form'))
    );
  }

  function buildSearchUrl(form, query) {
    var action = form.getAttribute('action') || '/search';
    var url = new URL(action, window.location.origin);
    var params = new URLSearchParams(new FormData(form));
    var previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');

    params.set('q', query);
    params.set('type', 'product');
    params.set('options[prefix]', 'last');

    if (previewThemeId) {
      params.set('preview_theme_id', previewThemeId);
    }

    url.search = params.toString();
    return url.toString();
  }

  function patchPredictiveSearch(ctor) {
    var prototype = ctor && ctor.prototype;
    var originalSetupUrl = prototype && prototype.setupURL;

    if (!prototype || prototype.__skuSearchPatched || typeof originalSetupUrl !== 'function') return;

    prototype.setupURL = function () {
      var url = originalSetupUrl.call(this);
      var input = this.input || getSearchInput(this);
      var query = cleanQuery(input && input.value);

      if (isSkuQuery(query)) {
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[options][fields]', SKU_SEARCH_FIELDS);
        url.searchParams.set('resources[options][unavailable_products]', 'last');
      }

      return url;
    };

    prototype.__skuSearchPatched = true;
  }

  installSearchButtonStyle();

  if (window.customElements) {
    var predictiveSearch = window.customElements.get('predictive-search');

    if (predictiveSearch) {
      patchPredictiveSearch(predictiveSearch);
    } else if (window.customElements.whenDefined) {
      window.customElements.whenDefined('predictive-search').then(patchPredictiveSearch);
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!isSearchForm(form)) return;

      var input = getSearchInput(form);
      var cleanValue = cleanQuery(input.value);

      if (isSkuQuery(cleanValue)) {
        input.value = cleanValue + '*';
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.href = buildSearchUrl(form, input.value);
      } else {
        input.value = cleanValue;
      }
    },
    true
  );
})();
